import 'es6-promise';
import 'isomorphic-fetch';
import * as Redux from 'redux';
import * as _ from 'lodash';
import * as actions from './index';
import { ISearchCriteria } from '../state-helpers/search-criteria'
import { IState } from '../reducers/index'
import { ICategoryResult } from '../state-helpers/categories';
import { pushInUrlQuery } from 'react-url-query';
import { updateSearchCategory, setSelectedCategoryCount } from './index';
import { getParameterByName } from '../../global/functions/query-string';

const fetchFromServer = (criteria: string) => {
    const init: RequestInit = {
        method: 'POST',
        body: criteria,
        headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
        cache: 'no-store'
    };

    return window.fetch('/api/v1/search/searchWithCriteria/', init)
        .then(function (response) {
            // Catch the timeout
            if (response.status === 504) {
                const errorMsg = new Error("Failed to fetch");
                errorMsg.message = "Failed to fetch";
                throw errorMsg;
            }
            // Catch the bad response
            else if (response.status >= 400) {
                const errorMsg = new Error("Bad response");
                errorMsg.message = "Bad response";
                throw errorMsg;
            }
            return response.json();
        })
};

// Custom cache: only stores successful responses with actual results.
// Errors and empty results are never cached.
const searchResultsSuccessCache: { [key: string]: any } = {};

// Helper function to safely get searchItemList from response
const getSearchItemList = (data: any): any[] | null => {
    if (data && data.data && data.data.result && data.data.result.searchItemList) {
        return data.data.result.searchItemList;
    }
    return null;
};

const cachedFetch = (criteria: string) => {
    // Verify if the criteria exists in Cache
    if (searchResultsSuccessCache.hasOwnProperty(criteria)) {
        const cachedData = searchResultsSuccessCache[criteria];
        const cachedSearchItemList = getSearchItemList(cachedData);
        
        // Verify if the results has data valid
        if (cachedSearchItemList && cachedSearchItemList.length > 0) {
            return Promise.resolve(cachedData);
        } else {
            // If cache has empty values, drop it and searchit againg
            delete searchResultsSuccessCache[criteria];
        }
    }

    return fetchFromServer(criteria).then(function (data) {
        
        // Verify the Structure response
        var searchItemList = getSearchItemList(data);
        var resultCount = searchItemList ? searchItemList.length : 0;

        // Only cache if we got actual results
        if (resultCount > 0) {
            searchResultsSuccessCache[criteria] = data;
        } else {
            console.log('[Search] Response NOT cached (empty results)');
        }
        return data;
    });
};

export function fetchResults(initialLoad = false, isMct = false) {
    return (dispatch, getState) => {
        let state = getState() as IState;

        var searchCriteria = JSON.stringify({
            SearchTerm: state.searchTermModel.trim(),
            Page: state.pageModel.page,
            PageSize: state.pageModel.pageSize,
            Facets: state.categoriesModel.categories,
            IsMCTSite: isMct
        })

        dispatch(actions.itemsAreLoading(true));
        cachedFetch(searchCriteria)
            .then(function (data) {
                console.log(data.data.result);
                let categoriesData = data.data.result.categories as ICategoryResult[];
                setCategoriesAndCount(dispatch, categoriesData);

                if (initialLoad) {
                    dispatch(actions.showResults(false));
                    dispatch(actions.itemsAreLoading(false));
                }
                else {
                    console.log(data.data.result.generativeResult)
                    dispatch(actions.showResults(true));
                    dispatch(actions.getResults(data.data.result));
                }                
            })
            .catch(err => {
                console.log(err);
                dispatch(actions.updateResultsFailure(err.message))
            });
    }
}

export function getSelectedCategoryCount(categories: ICategoryResult[]) {
    var currentCategories = _.clone(categories);
    var selectedCount = 0;

    for (var category = 0; category < currentCategories.length; category++) {
        var currentFilter = currentCategories[category];

        for (var filter = 0; filter < currentFilter.terms.length; filter++) {
            var currentTerm = currentFilter.terms[filter];

            if (currentTerm.selected === true) {
                selectedCount++;
            }
        }
    }

    return selectedCount;
}

export function setCategoriesAndCount(dispatch: Redux.Dispatch<IState>, categories: ICategoryResult[]) {

    dispatch(updateSearchCategory(categories));
    //dispatch(setSelectedCategoryCount(getSelectedCategoryCount(categories)));
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/actions/results.ts